import { render, staticRenderFns } from "./ReplyingTo.vue?vue&type=template&id=6d9bb9f6&"
import script from "./ReplyingTo.vue?vue&type=script&lang=js&"
export * from "./ReplyingTo.vue?vue&type=script&lang=js&"
import style0 from "./ReplyingTo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports